<script setup lang="ts">
import { computed } from 'vue'

import cn from 'internal/tailwind-classmerge'

import { Input, type InputProps } from '@fond-of/fondof-ui'

const props = defineProps<InputProps>()

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props
  return delegated
})
</script>

<template>
  <Input
    v-bind="delegatedProps"
    data-slot="control"
    :class="
      cn(
        'peer/input',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'group-hover/input:bg-gray-light-1',
        'bg-gray-ultra-light h-[46px] w-full px-[15px] pt-3.5 font-sans text-sm text-black outline-none lg:h-[52px]',
        props.class
      )
    "
    placeholder=" "
  />
</template>
